import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Dashboard from '../components/Dashboard';
import Login from '../components/login';


const PublicRoute = () => {
  const token = localStorage.getItem('token');
  if (token) {
    return <Navigate to="/dashboard" />  
  }
  return <Login/>
 
};

export default PublicRoute;
